<template>
    <div class="main_center">
        <div class="content common_header">
            <div class="search">
                <el-input
                    style="width:500px;"
                    :placeholder="placeholderArea"
                    v-model="searchKey"
                    @keyup.enter.native="seachBtn"
                    clearable
                ></el-input>
                <el-button type="primary" size="small" class="rightSearchBtn" @click="seachBtn">搜索</el-button>
            </div>
        </div>
        <div class="main_center" >
            <div class="content" style="min-height:calc(100vh - 80px - 234px)"  v-loading="dataListLoading">
                <el-table
                    :data="tableData"
                    v-loading="dataListLoading"
                    ref="multipleTable"
                    :height="tableMaxHeight"
                    stripe
                    border
                >
                    <el-table-column
                        fixed
                        label="序号"
                        type="index"
                        :index="indexMethod"
                        width="50"
                        align="center"
                        :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column label="操作" align="left" width="100" fixed="right">
                        <template slot-scope="scope">
                            <el-button
                                type="text"
                                size="small"
                                title="查看"
                                @click="router(scope.row)"
                            >查看</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="标段编号"
                        prop="tradePlatfBidSectionCode"
                        align="left"
                        min-width="180"
                        :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                        label="标段名称"
                        prop="bidSectionName"
                        align="left"
                        min-width="180"
                        :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                        label="招标项目编号"
                        prop="tradePlatfTenderProjectCode"
                        align="left"
                        min-width="180"
                        :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                        label="招标项目名称"
                        prop="tenderProjectName"
                        align="left"
                        min-width="180"
                        :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                        label="招标人"
                        prop="tendererName"
                        header-align="left"
                        align="left"
                        min-width="100"
                        :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                        label="招标方式"
                        prop="tenderModeName"
                        header-align="left"
                        align="left"
                        min-width="100"
                        :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                        label="修改人"
                        prop="updateBy"
                        header-align="left"
                        align="left"
                        min-width="150"
                        :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                        label="修改时间"
                        prop="updateDate"
                        header-align="left"
                        align="left"
                        min-width="150"
                        :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                        label="创建人"
                        prop="createBy"
                        header-align="left"
                        align="left"
                        min-width="150"
                        :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                        label="创建时间"
                        prop="createDate"
                        header-align="left"
                        align="left"
                        min-width="150"
                        :show-overflow-tooltip="true"
                    ></el-table-column>
                </el-table>
                <pagination
                    class="limit"
                    :page-sizes="[10, 20, 50, 100]"
                    :total="total"
                    :page.sync="pageIndex"
                    :limit.sync="pageSize"
                    @pagination="paginationChange"
                ></pagination>
            </div>
        </div>
    </div>
</template>
<script>
import Pagination from "@/components/Pagination.vue";
import {removeTabHandle} from "@/utils/routeTab";
export default {
    name: "busWitnessTable",
    components: {
        Pagination,
    },
    data() {
        return {
            placeholderArea: "请输入标段名称/标段编号/招标项目名称/招标编号/招标人",
            tableMaxHeight: document.documentElement.clientHeight - 275,
            dataListLoading: false,

            witnessStatuslist: [],
            flownodesListData: [],
            moreSearchItem: false,
            checkList1: "",
            pageSize: 10, //每页条数
            pageIndex: 1, //当前页
            total: 0, //总条数
            tableData: [],
            multipleSelection: [],
            user: "", //角色类型
            formData: {},
            transactionCenterList: [],
            searchKey: '',
        };
    },
    activated() {
        this.getDataList();
    },
    mounted() {
        const that = this;
        let resizeTag = true;
        window.onresize = () => {
            if (resizeTag) {
                //防抖动
                that.ifmove();
                resizeTag = false;
                setTimeout(() => {
                    resizeTag = true;
                }, 1000);
            }
        };
        that.ifmove();
    },
    methods: {
        // 获取列表数据
        getDataList() {
            this.dataListLoading = true;
            this.$http.get(`/nonCustomForm/getArchives?keywords=${this.searchKey}&pageIndex=${this.pageIndex}&pageSize=${this.pageSize}`)
                .then(res => {
                    if(res.data.code === '1') {
                        this.tableData = res.data.data.rows;
                        this.total = res.data.data.total;
                        this.$refs.multipleTable.doLayout();
                    }
                }).finally(() => {
                    this.dataListLoading = false;
                });
        },
        //跳转详情
        router(item) {
            // removeTabHandle('archive-detail')
            this.$router.push({
                name: "archive-detail",
                query: {
                    archiveId: item.archiveId
                }
            });
        },
        ifmove() {
            let tableMaxHeight =
                document.documentElement.clientHeight -
                328 + 41
            this.pageSize = parseInt(tableMaxHeight / 50) || 1;
            this.$nextTick(() => {
                this.tableMaxHeight = tableMaxHeight;
            });
        },
        // 分页
        paginationChange(obj) {
            this.pageIndex = obj.page || 1;
            this.pageSize = obj.limit || 5;
            this.getDataList();
        },
        //序号
        indexMethod(index) {
            return (this.pageIndex - 1) * this.pageSize + index + 1;
        },
        //搜索按钮
        seachBtn() {
            this.pageIndex = 1;
            this.getDataList();
        },
    },

    destroyed() {
        window.onresize = null;
    }
};
</script>
<style lang="less">
.common_header {
    .search {
        .el-input .el-input__inner,
        .el-input--medium .el-input__inner,
        .el-input--suffix .el-input__inner {
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
        }
        .rightSearchBtn {
            height: 32px;
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
        }
    }
}
</style>
<style lang="less" scoped>
@main-color: @--color-primary;
.common_header {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
    height: 80px;
    // box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .12), 0 0 6px 0 rgba(0, 0, 0, .04);
    > h2 {
        margin-bottom: 30px;
        font-weight: bold;
    }
    > .search {
        display: flex;
        justify-content: center;
        align-items: center;
        > .el-button--primary {
            background-color: @main-color;
            border-color: @main-color;
        }
    }
    > .my_nav {
        margin-top: 30px;
        > span {
            padding: 10px;
            cursor: pointer;
            position: relative;
            > i {
                font-style: normal;
                margin-left: 1px;
            }
            &:after {
                content: "";
                width: 0%;
                height: 2px;
                background: #1890ff;
                position: absolute;
                bottom: 0;
                left: 0;
                transition: all 0.7s;
            }
            &:hover {
                color: #1890ff;
            }
            &:hover:after {
                width: 100%;
            }
        }
        > .active {
            color: #1890ff;
            &:after {
                content: "";
                width: 100%;
                height: 2px;
                background: #1890ff;
                position: absolute;
                bottom: 0;
                left: 0;
            }
        }
    }
}
</style>
